/* Selected summary — expanded customize-your-own summary of chosen products */

export const selectedSummaryParts = [
  'selectedSummaryWrapper',
  'selectedSummaryTotalRow',
  'selectedSummaryTotalLabel',
  'selectedSummaryTotalPrice',
  'selectedSummaryItemRow',
  'selectedSummaryThumbnail',
  'selectedSummaryItemInfo',
  'selectedSummarySlotLabel',
  'selectedSummaryItemName',
  'selectedSummaryItemPrice'
];

export const selectedSummaryBaseStyle = {
  selectedSummaryWrapper: {
    borderTop: '1px solid',
    borderColor: 'brandColors.paleGrey',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  selectedSummaryTotalRow: {
    alignItems: 'center',
    borderBottom: '1px solid',
    borderColor: 'brandColors.paleGrey',
    display: 'flex',
    gap: '16px',
    paddingX: '20px',
    paddingY: '20px',
    minH: 15.5,
  },
  selectedSummaryTotalLabel: {
    color: '#000',
    flex: 1,
    fontSize: {base: '14px', lg: '16px'},
    fontVariantNumeric: 'lining-nums proportional-nums',
    fontWeight: 'semibold',
    lineHeight: 1.4,
    minWidth: 0,
  },
  selectedSummaryTotalPrice: {
    color: '#000',
    flexShrink: 0,
    fontSize: {base: '14px', lg: '16px'},
    fontVariantNumeric: 'lining-nums proportional-nums',
    fontWeight: 'semibold',
    lineHeight: 1.4,
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  
  selectedSummaryItemRow: {
    alignItems: 'center',
    alignSelf: 'stretch',
    borderBottom: '1px solid',
    borderColor: 'brandColors.paleGrey',
    display: 'flex',
    gap: '16px',
    paddingX: '20px',
    paddingY: '20px',
    minH: 17.5,
  },
  selectedSummaryThumbnail: {
    borderRadius: '4px',
    flexShrink: 0,
    height: '30px',
    objectFit: 'cover',
    width: '30px',
  },
  selectedSummaryItemInfo: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: '2px',
    justifyContent: 'center',
    minWidth: 0,
  },
  selectedSummarySlotLabel: {
    color: 'greyscale.70',
    fontSize: {base: '13px', lg: '12px'},
    fontWeight: 'normal',
    lineHeight: 1.2,
    noOfLines: 1,
  },
  selectedSummaryItemName: {
    color: '#000',
    fontSize: {base: '14px', lg: '16px'},
    fontWeight: 'normal',
    lineHeight: 1.4,
    noOfLines: 2,
  },
  selectedSummaryItemPrice: {
    color: '#000',
    flexShrink: 0,
    fontSize: {base: '14px', lg: '16px'},
    fontWeight: 'normal',
    lineHeight: 1.4,
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
};
